/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    shape, string, number,
    bool, arrayOf, func, object,
} from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import AnimatedCheck from '../../../../assets/svg/AnimatedCheck';
import EventDispatcher from '../../../../state/reducers/EventDispatcher';
import { decode as htmlDecode } from '../../../../utils/htmlEntity';
import configENV from '../../../../config';
import { isEmpty } from '../../../../utils/object';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const { PERSIST_KEY } = configENV;

const styles = () => ({
    contentWrapper: {
        margin: 24,
        paddingBottom: 24,
        display: 'flex',
        '& .buttonWrapper': {
            marginLeft: 12,
        },
        '& .undoButton': {
            marginRight: '0 !important',
            position: 'relative',
            top: '-3px',
        },
    },
});

const ProductAddedToCart = ({
    classes, recipient,
    handleGiftListChooseSomethingDifferent, isReadyState, isGiftListV2,
}) => {
    if (isEmpty(recipient.cartDetail)) return null;
    const dispatch = useDispatch();
    const product = recipient.cartDetail;
    const newName = htmlDecode(product.productDetail.name);
    const chooseSomethingDifferentLabel = isReadyState
        ? 'Undo'
        : 'Removing...';
    return (
        <div className={classes.contentWrapper}>
            <div>
                <AnimatedCheck className="success-color margin-right-half" />
            </div>
            <div>
                <span className="">
                    {newName} {!isGiftListV2 && (product.productDetail.sku)}
                </span>
                <span>
                    {' '}
                    is currently in your cart for {recipient.firstname}{' '}
                    {recipient.lastname}.
                </span>
            </div>
            {!isGiftListV2 &&  (
                <div className="buttonWrapper">
                    <Button
                        className="secondary small undoButton"
                        onClick={() => {
                            handleGiftListChooseSomethingDifferent(recipient);
                            dispatch(trackEvent({
                                eventCategory: 'Gift List V1',
                                eventAction: 'Item Removed',
                                eventLabel: product?.productDetail?.sku || '',
                            }));
                        }}
                    >
                        {chooseSomethingDifferentLabel}
                    </Button>
                </div>
            )}
        </div>
    );
};

ProductAddedToCart.defaultProps = {
    recipient: {},
    handleGiftListChooseSomethingDifferent: '',
    isGiftListV2: false,
};

ProductAddedToCart.propTypes = {
    classes: object.isRequired,
    recipient: shape({
        AddressBookEntryId: string,
        addToCart: string,
        address: shape({
            addressId: string,
            apt: string,
            city: string,
            company: string,
            country: shape({
                id: string,
                name: string,
            }),
            location: shape({
                id: number,
                name: string,
            }),
            state: shape({
                id: string,
                name: string,
            }),
            street: string,
            zipcode: string,
        }),
        addressId: string,
        firstname: string,
        giftArrived: string,
        id: string,
        isNewRecipient: bool,
        lastname: string,
        occasionId: string,
        orderItemId: string,
        products: arrayOf(
            shape({
                content: string,
                crossedPrice: string,
                discountPrice: string,
                id: string,
                image: string,
                name: string,
                parentCatalogEntryId: string,
                partNumber: string,
                price: number,
                seoproductDisplayURL: string,
                sku: string,
                status: string,
            }),
        ),
        type: string,
    }),
    isReadyState: bool.isRequired,
    handleGiftListChooseSomethingDifferent: func,
    isGiftListV2: bool,
};

const mapStateToProps = (state) => {
    /* istanbul ignore next */
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isReadyState: newState.isReadyState,
        // recipient: newState.modal.content,
        addToCart:
            typeof newState.modal.content === 'object'
                ? newState.modal.content.addToCart
                : '',
    };
};

const mapDispatchToProps = (dispatch) => ({
    handleGiftListChooseSomethingDifferent: (recipient) => dispatch(EventDispatcher.handleGiftListChooseSomethingDifferent(recipient)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withStyles(styles)(ProductAddedToCart));
